
export default function UniversitiesSection() {
  const universities = [
    {
      name: "Universidad de Santiago de Chile",
      location: "Santiago",
      program: "Bachillerato en Ciencias y Humanidades",
      logo: "ri-building-line"
    },
    {
      name: "Universidad de Chile",
      location: "Santiago",
      program: "Programa de Bachillerato",
      logo: "ri-school-line"
    },
    {
      name: "Pontificia Universidad Católica de Chile",
      location: "Santiago",
      program: "College UC",
      logo: "ri-graduation-cap-line"
    },
    {
      name: "Universidad de Concepción",
      location: "Concepción",
      program: "Bachillerato en Ciencias",
      logo: "ri-book-open-line"
    },
    {
      name: "Universidad Austral de Chile",
      location: "Valdivia",
      program: "Bachillerato en Ciencias",
      logo: "ri-plant-line"
    },
    {
      name: "Universidad de La Frontera",
      location: "Temuco",
      program: "Bachillerato en Ciencias de la Ingeniería",
      logo: "ri-compass-line"
    },
    {
      name: "Universidad de Valparaíso",
      location: "Valparaíso",
      program: "Bachillerato en Ciencias",
      logo: "ri-ship-line"
    },
    {
      name: "Universidad Católica del Norte",
      location: "Antofagasta",
      program: "Bachillerato en Ciencias",
      logo: "ri-sun-line"
    },
    {
      name: "Universidad de Antofagasta",
      location: "Antofagasta",
      program: "Bachillerato en Ciencias",
      logo: "ri-mountain-line"
    }
  ];

  return (
    <section id="universidades" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Universidades Participantes
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Una red colaborativa que reúne a las principales universidades chilenas 
              comprometidas con la excelencia en programas de bachillerato
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {universities.map((university, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4">
                    <i className={`${university.logo} text-blue-600 text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900 text-lg leading-tight">
                      {university.name}
                    </h3>
                    <p className="text-gray-500 text-sm flex items-center mt-1">
                      <i className="ri-map-pin-line mr-1"></i>
                      {university.location}
                    </p>
                  </div>
                </div>
                <div className="bg-blue-50 rounded-lg p-3">
                  <p className="text-blue-800 font-medium text-sm">
                    {university.program}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  Diversidad y Colaboración
                </h3>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  Nuestra red abarca universidades desde Antofagasta hasta Valdivia, 
                  representando la diversidad geográfica y académica de Chile. Cada institución 
                  aporta su experiencia única en programas de bachillerato.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-600"></i>
                    </div>
                    <span className="text-gray-700">Respeto por la autonomía institucional</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-600"></i>
                    </div>
                    <span className="text-gray-700">Intercambio de mejores prácticas</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-600"></i>
                    </div>
                    <span className="text-gray-700">Desarrollo conjunto de iniciativas</span>
                  </div>
                </div>
              </div>
              <div>
                <img 
                  src="/images/0d6171cbc488c1ee6b66f3626d0dcda5.jpg"
                  alt="Mapa de Universidades RENABACH"
                  className="rounded-2xl shadow-lg object-cover w-full h-96"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
